(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('Paie', Paie);

    Paie.$inject = ['$resource', 'DateUtils'];

    function Paie ($resource, DateUtils) {
        var resourceUrl =  'api/paies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.month = DateUtils.convertLocalDateFromServer(data.month);
                        data.monthPrime = DateUtils.convertLocalDateFromServer(data.monthPrime);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.month = DateUtils.convertLocalDateToServer(copy.month);
                    copy.monthPrime = DateUtils.convertLocalDateToServer(copy.monthPrime);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.month = DateUtils.convertLocalDateToServer(copy.month);
                    copy.monthPrime = DateUtils.convertLocalDateToServer(copy.monthPrime);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
